export const routes = {
  analytics: '/analytics',
  planning: '/planning/:tab',
  settings: '/settings/:tab',
  business: '/businessOptimization',
}
